export const enum Breakpoints {
  FULL = 'full',
  LARGE = 'large',
  MEDIUM = 'medium',
  MINIMUM = 'minimum',
  HIDDEN = 'hidden',
}

/* пискельные брекпоинты под размер экрана */
export type DrawerLimiter = Partial<Record<Breakpoints, number>>

export type DrawerRefState = {
  clientY?: number
  currentOffset?: number
  initialScreenY?: number
  limiter?: DrawerLimiter
  now?: number
  moved: boolean
  movable: boolean
}

export type DrawerProps = {
  className?: string
  /* Отрыть шторку до breakpoints.max */
  open?: boolean
  /* Брэкпоинты */
  breakpoints?: {
    /* Минимальный брекпоинт */
    min?: Breakpoints
    /* Максимальный брекпоинт */
    max?: Breakpoints
    /* С какого положения начинать затемнение */
    darken?: Breakpoints
    /* Начальное положение шторки */
    default?: Breakpoints
    /* Список брекпоинтов к которым шторка может притянуться */
    active?: Partial<Breakpoints>[]
  }
  /* Коэффициенты от общей высоты экрана по которым определяются брекпоинты */
  breakpointsCoefficients?: Partial<Record<Breakpoints, number>>
  /* TODO убрать gap и упросить кастомизацию размеров шторки */
  gap?: number
  maxHeight?: number
  /* Можно ли скрыть шторку */
  closable?: boolean
  /* Высота шторки по контенту */
  fitContent?: boolean
  /* Коллбэк закрытия */
  onClose?: VoidFunction
  /* Виды эспандера */
  expanderType?: 'inside' | 'outside' | 'none'
  /* Коллбэк достижения максимального значения */
  onMax?: VoidFunction
  /* Коллбэк достижения минимального значения */
  onMin?: VoidFunction
}

export type IDrawerContext = {
  containerRef?: React.RefObject<HTMLDivElement>
  contentRef?: React.RefObject<HTMLDivElement>
}
